import React, { useEffect, useState, useCallback, useMemo } from 'react';
import axios from 'axios';
import { roomFacilitesColumns } from './RoomFacilitesData';
import DataTable from '../../../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../../../Common/DataTableFooter/DataTableFooter';
import EditFacilities from './EditFacilites';
import { REACT_APP_API_URL } from '../../../../../../env';

const RoomFacilitiesTable = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFacilityId, setSelectedFacilityId] = useState(null);

  const fetchFacilities = useCallback(async () => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/facilities/get/room-facilities`);
      console.log("Facilities fetched:", response.data);
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching facilities:', error);
    }
  }, []);

  useEffect(() => {
    fetchFacilities();
  }, [fetchFacilities]);

  const handleDelete = useCallback(async (id) => {
    try {
      await axios.delete(`${REACT_APP_API_URL}api/facilities/delete-facility/${id}`);
      setData((prevData) => prevData.filter((item) => item.FacilityID !== id));
      alert('Facility deleted successfully!');
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete facility.');
    }
  }, []);

  const handleEditClick = useCallback((id) => {
    setSelectedFacilityId(id);
    setModalOpen(true);
  }, []);

  const dataT = useMemo(() => {
    return data.map((item) => ({
      facilitesId: item.FacilityID,
      facilityName: item.FacilityTitle || 'N/A',
      facilitesDescription: item.FacilityDescription || '',
      actions: (
        <>
          <button onClick={() => handleEditClick(item.FacilityID)}>
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="btn deleterow" onClick={() => handleDelete(item.FacilityID)}>
            <i className="bi bi-trash text-danger"></i>
          </button>
        </>
      ),
    }));
  }, [data, handleEditClick, handleDelete]);

  return (
    <>
      <DataTableHeader columns={roomFacilitesColumns} data={dataT} />
      <DataTable columns={roomFacilitesColumns} data={dataT} enablePagination={false} />
      <DataTableFooter dataT={dataT} />
      <EditFacilities
        isOpen={modalOpen}
        facilityId={selectedFacilityId}
        onClose={() => {
          setModalOpen(false);
          setSelectedFacilityId(null);
        }}
        onUpdated={fetchFacilities}
      />
    </>
  );
};

export default React.memo(RoomFacilitiesTable);
